import { render, staticRenderFns } from "./website-page.vue?vue&type=template&id=5c927916&scoped=true"
import script from "./website-page.vue?vue&type=script&lang=js"
export * from "./website-page.vue?vue&type=script&lang=js"
import style0 from "./website-page.vue?vue&type=style&index=0&id=5c927916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c927916",
  null
  
)

export default component.exports